// src/KlinikRoutes.js (Tam Kod)
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import KlinikDiyetisyenler from './KlinikDiyetisyenler';
import KlinikDanisanlar from './KlinikDanisanlar'; // Yeni bileşeni import et
import KlinikTakvim from './KlinikTakvim';
import KlinikDashboard from './KlinikDashboard';
import RandevuAtama from './RandevuAtama'; 
import Profil from './Profil';

function KlinikRoutes({ theme, themePreset, onThemeChange }) {
  return (
    <Routes>
      <Route path="/" element={<KlinikDashboard theme={theme} />} />
      <Route path="/takvim" element={<KlinikTakvim theme={theme} />} />
      <Route path="/randevu-ata" element={<RandevuAtama theme={theme} />} />
      <Route path="/diyetisyenler" element={<KlinikDiyetisyenler theme={theme} />} />
      <Route path="/danisanlar" element={<KlinikDanisanlar theme={theme} />} />
      <Route path="/profil" element={<Profil theme={theme} themePreset={themePreset} onThemeChange={onThemeChange} />} />
    </Routes>
  );
}
export default KlinikRoutes;